<div *ngFor="let data of criterias" class="criteria">
  <span>
    {{data.key}} 
  </span>
  <span>
    {{data.value}}
  </span>
</div>
